import { NavigationMenuContent } from '@/components/NavigationMenu';
import {
  CloseButton,
  DataList,
} from '@/components/NewHeader/NavBar/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';

export function Guides() {
  const {
    newHeader: { guides, nav },
  } = useTranslation();

  const { sendMenuClickEvent } = useGTMEvents();

  const section = nav.find((item) => item.id === 'guides')?.title || 'Guides';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <NavigationMenuContent className="right-[12%] xl:right-[15%] 2xl:right-[18%] [@media(min-width:2000px)]:right-[25%] left-auto">
      <div className="grid grid-cols-1 gap-4">
        <div className="py-12 px-20 space-y-16">
          <div className="grid grid-cols-2 gap-20 gap-y-6">
            <DataList
              onItemClick={handleItemClick}
              data={guides.sicilyGuides}
              smallContainer
            />
            <DataList
              onItemClick={handleItemClick}
              data={guides.pugliaGuides}
              smallContainer
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center pb-2">
        <CloseButton />
      </div>
    </NavigationMenuContent>
  );
}
